import React from 'react';
import CourseTemplate from '../../components/CourseTemplate';

const BEFoodTechnologyCoursePage: React.FC = () => {
  const courseData = {
    title: "B.E. Food Technology",
    shortName: "B.E. Food Tech",
    duration: "4 years",
    description: "Engineering program focused on food processing, preservation, quality control, and food safety systems",
    overview: "Bachelor of Engineering in Food Technology (B.E. Food Tech) is a 4-year undergraduate program that applies engineering principles to food processing, preservation, packaging, and distribution. This course covers food chemistry, microbiology, processing technology, quality assurance, and food safety, preparing students for careers in the food and beverage industry.",
    eligibility: [
      "10+2 with Physics, Chemistry, Mathematics",
      "Biology/Biotechnology preferred but not mandatory",
      "Minimum 75% marks in JEE Main (50% for SC/ST)",
      "Valid JEE Main/State CET scores"
    ],
    
    curriculum: [
      {
        year: 1,
        subjects: [
          "Mathematics-I & II",
          "Physics",
          "Chemistry",
          "Biology for Engineers",
          "Engineering Graphics",
          "Introduction to Food Technology"
        ]
      },
      {
        year: 2,
        subjects: [
          "Food Chemistry",
          "Food Microbiology",
          "Biochemistry",
          "Thermodynamics",
          "Fluid Mechanics",
          "Food Analysis"
        ]
      },
      {
        year: 3,
        subjects: [
          "Food Processing Technology",
          "Food Preservation",
          "Food Packaging Technology",
          "Dairy Technology",
          "Food Quality Control",
          "Food Safety and HACCP"
        ]
      },
      {
        year: 4,
        subjects: [
          "Food Plant Engineering",
          "Food Biotechnology",
          "Nutrition and Dietetics",
          "Food Laws and Regulations",
          "Project Work",
          "Industrial Training"
        ]
      }
    ],

    careerProspects: {
      roles: [
        "Food Technologist",
        "Quality Control Manager",
        "Food Safety Officer",
        "Production Manager",
        "R&D Engineer",
        "Food Process Engineer",
        "Nutrition Consultant",
        "Food Inspector",
        "Product Development Manager",
        "Food Analyst"
      ],
      industries: [
        "Food Processing Companies",
        "Beverage Industry",
        "Dairy Industry",
        "Bakery and Confectionery",
        "Spice and Seasoning",
        "Frozen Food Industry",
        "Food Packaging",
        "Government Food Agencies",
        "Research Institutions",
        "Hotel and Restaurant Chains"
      ],
      averageSalary: "₹4-8 LPA (Fresher), ₹12-30 LPA (Experienced)",
      topRecruiters: [
        "ITC, Hindustan Unilever",
        "Nestle, Britannia",
        "Amul, Mother Dairy",
        "PepsiCo, Coca-Cola",
        "McCain, Haldiram's",
        "Food Safety and Standards Authority"
      ]
    },

    admissionProcess: [
      "TNEA Counselling (for Tamil Nadu colleges)",
      "JEE Main (for NITs and central universities)",
      "State-level entrance exams",
      "Management quota admissions",
      "Direct admission based on 12th marks"
    ],

    topColleges: [
      {
        name: "Central Food Technological Research Institute",
        location: "Mysore",
        fees: "₹3,00,000",
        ranking: "Premier Food Research Institute"
      },
      {
        name: "National Institute of Food Technology",
        location: "Thanjavur",
        fees: "₹2,50,000",
        ranking: "Deemed University"
      },
      {
        name: "SRM Institute of Science and Technology",
        location: "Chennai",
        fees: "₹12,00,000",
        ranking: "NIRF Ranking: 41"
      },
      {
        name: "VIT University",
        location: "Vellore",
        fees: "₹7,83,000",
        ranking: "NIRF Ranking: 15"
      }
    ],

    skills: [
      "Food Processing Technology",
      "Quality Control Systems",
      "HACCP and Food Safety",
      "Food Analysis Techniques",
      "Process Design",
      "Food Packaging",
      "Sensory Evaluation",
      "Regulatory Compliance",
      "Product Development",
      "Supply Chain Management"
    ],

    futureScope: "Excellent growth prospects with expanding food industry, processed food demand, health-conscious consumers, and government focus on food safety and nutrition.",

    faqs: [
      {
        question: "What career opportunities exist in Food Technology?",
        answer: "Food technologists work in product development, quality control, production management, food safety, research, and regulatory roles across the food industry."
      },
      {
        question: "Can I start my own food business?",
        answer: "Yes, food technology provides excellent foundation for starting food processing businesses, restaurants, or consultancy services with proper knowledge of regulations and processes."
      },
      {
        question: "Are there government job opportunities?",
        answer: "Yes, opportunities exist in Food Safety and Standards Authority of India (FSSAI), agricultural departments, and public distribution systems."
      },
      {
        question: "Is the field suitable for those interested in nutrition?",
        answer: "Yes, food technology covers nutrition science and many graduates work as nutrition consultants, dietitians, or in health food development."
      }
    ]
  };

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-[#0f172a] via-[#1e293b] to-black flex flex-col items-center justify-start py-8 px-2">
      <h1 className="text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-pink-400 to-purple-400 drop-shadow-glow mb-6 text-center animate-glow">
        {courseData.title}
      </h1>
      <div className="w-full max-w-4xl">
        <CourseTemplate courseData={courseData} />
      </div>
    </div>
  );
};

export default BEFoodTechnologyCoursePage;
